import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const EmptyPlayersMessageContainer = styled.div`
  font-family: 'SF Pro Display', sans-serif;
  color: ${theme.colors.SurfaceRomanSilver30};
  text-align: center;
`;
